import React from 'react'
import { Container } from './styles'
import VideoViewer from '../VideoViewer'

interface Props {
    videos: {
        arrayVideo: string[],
        positionVideo: number
    }
}
//Show full size photo
const VideoContent: React.FC<Props> = ({ videos }) => {


    return (
        <>
            <Container>
                <VideoViewer src={videos.arrayVideo[videos.positionVideo]} />
            </Container>
        </>
    )
}

export default VideoContent
